module.exports = __webpack_public_path__ + "static/src/content/images/processed/400/Sorcerers-Apprentice-The.70e35b8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/400/Sorcerers-Apprentice-The.jpg
// module id = zv62
// module chunks = 0